import locationIcon from "../../../assets/icons/location-pin.png";
import { useEffect, useState, useRef } from "react";
import { MAIN_PAGE } from "../../../data/texts";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Search } from "lucide-react";

const Banner = ({ specialitiesRes }) => {
  const navigate = useNavigate();
  const hero = MAIN_PAGE.slider?.[0];
  const [searchValue, setSearchValue] = useState("");
  const [cities, setCities] = useState([]);
  const [selectedCity, setSelectedCity] = useState("");

  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    axios
      .get("https://medizenapi.ir/v1/location/getCities?country_id=103")
      .then((res) => {
        if (res.data?.response_status === "success") {
          setCities(res.data.data || []);
        }
      });

    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const formatTitle = (title) => {
    if (!title) return null;
    return title.split(" ").map((word, index) => (
      <span key={index} className={word === "آنلاین" ? "text-purple" : ""}>
        {word}{" "}
      </span>
    ));
  };

  const handleSearchClick = (e) => {
    e.preventDefault();
    if (!searchValue.trim()) return;
    const params = new URLSearchParams();
    params.append("search", searchValue);
    if (selectedCity) params.append("city", selectedCity);
    navigate(`/doctors?${params.toString()}`);
  };

  const currentSpecialties = specialitiesRes?.data || [];
  const handleSpecialtyClick = (specialtyTitle) => {
    const params = new URLSearchParams();
    params.append("specialty", specialtyTitle);

    if (selectedCity) params.append("city", selectedCity);

    navigate(`/doctors?${params.toString()}`);
  };

  if (!hero) return null;

  return (
    <div
      className="relative w-full rounded-2x
       md:rounded-3xl min-h-[350px] 
      lg:h-[420px] overflow-hidden shadow-sm "
      onClick={() => setIsOpen(false)}
    >
      {/* عکس پس‌زمینه بنر */}
      <img
        className="absolute inset-0 w-full h-full object-cover object-right md:object-center"
        src={hero.bg}
        alt="banner"
      />

      {/* محتوای روی بنر */}
      <div
        className="absolute z-10 h-full inset-0
        w-full lg:w-[55%]
        flex flex-col justify-center items-center lg:items-start gap-1.5 lg:gap-2
        px-5 sm:px-8 lg:ps-12 bg-white/40 lg:bg-transparent
         backdrop-blur-[2px] lg:backdrop-blur-none
        "
      >
        <div className="flex flex-col items-center lg:items-start
         text-center lg:text-right gap-1.5">
          <span className="text-[10px] lg:text-[13px] font-medium text-gray-600">
            {hero.subtitle}
          </span>
          <h1 className="text-[#262626] text-[15px] lg:text-[24px] font-bold">
            {formatTitle(hero.title)}
          </h1>
        </div>

        <div
          className="text-[#505050] leading-[21px] lg:leading-[28px]
        text-[12px] text-center lg:text-right lg:text-[14px] opacity-90 max-w-lg"
        >
          {hero.desc}
        </div>
<form
  className="w-full max-w-lg relative flex flex-col lg:flex-row lg:items-center gap-2 lg:gap-0
   mt-1"
  onSubmit={handleSearchClick}
  onClick={(e) => e.stopPropagation()}
>
  {/* ردیف اصلی input + فیلتر */}
  <div
    className="relative flex items-center h-[44px] lg:h-[54px] w-full bg-white rounded-xl lg:rounded-2xl border-2 border-gray-100 
    focus-within:border-purple/50 transition-colors"
  >
    <input
      type="text"
      value={searchValue}
      onChange={(e) => setSearchValue(e.target.value)}
      placeholder="جستجوی پزشک یا تخصص"
      className="w-full h-full ps-3 md:ps-5 bg-transparent rounded-xl lg:rounded-2xl outline-none
      placeholder:text-[11px] lg:placeholder:text-[14px] text-gray-700"
    />

    {/* فیلتر شهر */}
    <div
      className="absolute left-[4px] lg:left-[50px] flex items-center h-8 lg:h-10"
      ref={dropdownRef}
    >
      <div
        onClick={() => setIsOpen(!isOpen)}
        className="h-full cursor-pointer bg-gray-50 border border-gray-200
         hover:bg-gray-100 transition-colors
        rounded-[9px] lg:rounded-[12px] px-1.5 lg:px-3 text-[10px] md:text-[12px] min-w-[70px]
        text-center select-none flex justify-center gap-1 items-center text-gray-600"
      >
        <img
          src={locationIcon}
          alt="location"
          className="w-3 md:w-3.5 object-contain opacity-70"
        />
        <span>{selectedCity || "همه شهرها"}</span>
      </div>

      {isOpen && (
        <div
          className="absolute bottom-full mb-2 lg:bottom-auto lg:top-full lg:mt-2 left-0
          w-full max-h-40 overflow-y-auto bg-white border border-gray-100
          rounded-xl shadow-[0_10px_25px_rgba(0,0,0,0.05)] z-[70] scrollbar-hide"
        >
          <div
            className="pb-1 pt-1.5 px-3 hover:bg-gray-50 cursor-pointer text-[10px] md:text-[12px]
             text-gray-600 border-b border-gray-50"
            onClick={() => {
              setSelectedCity("");
              setIsOpen(false);
            }}
          >
            همه شهرها
          </div>
          {cities?.map((city) => (
            <div
              key={city.id}
              className="py-1.5 px-3 hover:bg-gray-50 cursor-pointer text-[10px] md:text-[12px] text-gray-600"
              onClick={() => {
                setSelectedCity(city.name);
                setIsOpen(false);
              }}
            >
              {city.name}
            </div>
          ))}
        </div>
      )}
    </div>

    {/* دکمه سرچ فقط برای لپ‌تاپ */}
    <button
      type="submit"
      disabled={!searchValue.trim()}
      className={`hidden lg:flex h-9 lg:h-10 px-2 rounded-lg lg:rounded-xl transition-colors
      absolute left-1.5 w-9 lg:w-10 items-center justify-center
      ${
        !searchValue.trim()
          ? "bg-purple/10 text-purple/40"
          : "bg-purple/10 text-purple hover:bg-purple hover:text-white"
      }`}
    >
      <Search className="w-[18px] h-[18px]" strokeWidth={2} />
    </button>
  </div>

  {/* دکمه سرچ مخصوص موبایل */}
  <button
    type="submit"
    disabled={!searchValue.trim()}
    className={`lg:hidden w-full h-[38px] rounded-xl text-[13px]
       transition-colors flex items-center justify-center -mt-0.5
    ${
      !searchValue.trim()
        ? "bg-purple/10 text-purple/40"
        : "bg-purple text-white hover:bg-purple/90"
    }`}
  >
    جستجو
  </button>
</form>


        {/* پربازدیدترین تخصص‌ها - تغییر یافته به رنگ خنثی و مینیمال */}
        <div className="flex w-full justify-center lg:justify-start flex-wrap gap-1 gap-1.5">
          {currentSpecialties?.map((spec) => (
            <button
              key={spec.id}
              className="text-gray-600 bg-white/50 backdrop-blur-sm border border-gray-200/80 
              hover:bg-white hover:text-gray-800 transition-all 
              rounded-lg lg:rounded-xl px-2 py-1 lg:px-3 lg:py-1.5 text-[10px] lg:text-[12px] font-medium"
              onClick={(e) => {
                e.stopPropagation();
                handleSpecialtyClick(spec.title);
              }}
            >
              {spec.title}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Banner;
